import {Food} from "./types";

const BreakfastMeals: Food = {
    "Southwestern (Turkey)": {
        "Breakfast Pots": "4oz",
        "Ground Turkey": "2.5oz",
        "Scrambled Eggs": "2oz",
        "Mexican Cheese": "14g",
        "Sides": "Chipotle Yogurt topped with fajita veggie"
    },
    "Southwestern (Beef)": {
        "Breakfast Pots": "4oz",
        "Ground Beef": "2.5oz",
        "Scrambled Eggs": "2oz",
        "Mexican Cheese": "14g",
        "Sides": "Chipotle Yogurt topped with fajita veggie"
    },
    "Breakfast Feast (Sweet) Potatoes": {
        "Ground Turkey": "3oz",
        "Scrambled Eggs": "3oz",
        "Diced Sweet Potatoes": "4oz"
    },
    "Breakfast Feast (Red) Potatoes": {
        "Ground Turkey": "3oz",
        "Scrambled Eggs": "3oz",
        "Breakfast Red Potatoes": "4oz"
    },
    "Breakfast Burrito (Turkey)": {
        "Turkey Burrito": "1 sliced Turkey Burrito",
        "Sides": "Breakfast Salsa"
    },
    "Breakfast Burrito (Beef)": {
        "Turkey Burrito": "1 sliced Beef Burrito",
        "Sides": "Breakfast Salsa"
    },
    "Korean Beef Breakfast": {
        "Scrambled Eggs": "3oz",
        "Korean Beef": "4.2oz",
        "Jasmine Rice": "4.5oz (WHITE scoop)",
        "Garnish": "green onion"
    },
    "Protein French Toast": {
        "French Toast": "4 slices",
        "Scrambled Eggs": "(Green Scoop)",
        "Sides": "Sugar Free Syrup",
        "Fruit Cup": "3.25cz"
    }
}

export default BreakfastMeals